import { render, staticRenderFns } from "./InvoiceContact.vue?vue&type=template&id=16ee91d0"
import script from "./InvoiceContact.vue?vue&type=script&lang=js"
export * from "./InvoiceContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports